/**
 * Contexte pour la vue équipe.
 * Permet de basculer entre "mes données" et "données de mon équipe".
 */

import React, { createContext, useContext, useState } from "react";

const TeamViewContext = createContext(null);

export function useTeamView() {
  return useContext(TeamViewContext);
}

export function TeamViewProvider({ children }) {
  const [teamView, setTeamView] = useState(false);

  function toggleTeamView() {
    setTeamView((prev) => !prev);
  }

  return (
    <TeamViewContext.Provider value={{ teamView, setTeamView, toggleTeamView }}>
      {children}
    </TeamViewContext.Provider>
  );
}
